import { find } from 'lodash';
import { scrollToTop, goToRoute } from '@/utils';

export default (config) => {
  const initialStep = find(config.steps, (step) => step.entryPoint);
  return {
    data() {
      return {
        processTitle: config.defaultTitle,
        previousStep: null,
        currentStep: initialStep,
        currentStepId: initialStep.id,
        currentComponent: initialStep.component,
        nextStepId: null,
        previousStepId: null,
        withMainBackground: false,
        withFooterBackground: false,
        componentData: {},
      };
    },
    computed: {
      classContainer() {
        return `${this.currentStep.id}__container`;
      },
    },
    methods: {
      backHandler() {
        const previousStep = this.getStepById(this.previousStepId);
        if (previousStep) {
          this.currentStep = previousStep;
          return this.currentStep;
        }
        return this.defaultBackAction();
      },
      continueHandler() {
        const nextStep = this.getStepById(this.nextStepId);
        if (nextStep) {
          this.currentStep = nextStep;
          return this.currentStep;
        }
        this.defaultBackAction();
        return null;
      },
      getStepById(stepId) {
        const filteredStep = find(config.steps, (step) => {
          return stepId === step.id;
        });
        return filteredStep;
      },
      defaultBackAction() {
        const allowedRoutes = ['manageSeries', 'pendingFundsUndoChanges', 'addFundToSeries'];
        if (allowedRoutes.includes(this.$route.name)) {
          try {
            window.history.go(-1); // to reload the component
          } catch (err) {
            return goToRoute(this.$route, this.$router, '/');
          }
          return false;
        }
        if (this.$route.name !== 'grid') {
          return goToRoute(this.$route, this.$router, '/');
        }
        return false;
      },
    },
    watch: {
      currentStep: {
        immediate: true,
        handler(newStep, previousStep) {
          this.previousStep = previousStep;
          this.currentStepId = newStep.id;
          this.currentComponent = newStep.component;
          this.processTitle = newStep.processTitle;
          this.previousStepId = newStep.previousStepId;
          this.nextStepId = newStep.nextStepId;
          this.withMainBackground = newStep.withMainBackground;
          this.withFooterBackground = newStep.withFooterBackground;
          scrollToTop();
        },
      },
    },
  };
};
